import { helper } from "lib/helper";
import FeedBack from "models/feedback.modal";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import moment from "moment";

const Feedback = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for feedback
    const dummyData = {
      data: [
        {
          id: "1",
          auth_user: {
            first_name: "Rajesh",
            last_name: "Kumar"
          },
          type: "Feedback",
          recommendation: "5 Stars",
          textfield: "Excellent teaching quality and very supportive tutors. My child has improved significantly in mathematics.",
          updatedAt: "2024-01-15T10:30:00Z"
        },
        {
          id: "2",
          auth_user: {
            first_name: "Priya",
            last_name: "Sharma"
          },
          type: "Complaint",
          recommendation: "Technical Issues",
          textfield: "The online platform sometimes has connectivity issues during live classes. Please improve the server stability.",
          updatedAt: "2024-01-16T14:20:00Z"
        },
        {
          id: "3",
          auth_user: {
            first_name: "Amit",
            last_name: "Verma"
          },
          type: "Feedback",
          recommendation: "4 Stars",
          textfield: "Good experience overall. The tutor is knowledgeable but could be more interactive during sessions.",
          updatedAt: "2024-01-17T09:15:00Z"
        },
        {
          id: "4",
          auth_user: {
            first_name: "Sunita",
            last_name: "Gupta"
          },
          type: "Feedback",
          recommendation: "5 Stars",
          textfield: "Amazing platform! My daughter loves the physics classes and the tutor explains concepts very clearly.",
          updatedAt: "2024-01-18T16:45:00Z"
        },
        {
          id: "5",
          auth_user: {
            first_name: "Vikash",
            last_name: "Singh"
          },
          type: "Complaint",
          recommendation: "Scheduling Issues",
          textfield: "There are frequent changes in class timings without proper notice. This affects my child's study routine.",
          updatedAt: "2024-01-19T11:30:00Z"
        },
        {
          id: "6",
          auth_user: {
            first_name: "Meera",
            last_name: "Patel"
          },
          type: "Feedback",
          recommendation: "3 Stars",
          textfield: "The content is good but the session duration could be longer for better understanding of complex topics.",
          updatedAt: "2024-01-20T13:25:00Z"
        },
        {
          id: "7",
          auth_user: {
            first_name: "Arjun",
            last_name: "Reddy"
          },
          type: "Feedback",
          recommendation: "5 Stars",
          textfield: "Exceptional service! The chemistry tutor helped my son crack JEE Advanced. Highly recommended!",
          updatedAt: "2024-01-21T08:10:00Z"
        },
        {
          id: "8",
          auth_user: {
            first_name: "Kavita",
            last_name: "Joshi"
          },
          type: "Complaint",
          recommendation: "Payment Issues",
          textfield: "There was a double deduction from my account last month. Please check and refund the extra amount.",
          updatedAt: "2024-01-22T15:40:00Z"
        }
      ],
      meta: {
        current_page: 1,
        per_page: 20,
        total_page: 1,
        total: 8
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyData);
      setCurrentPage(dummyData.meta.current_page);
      setPerPage(dummyData.meta.per_page);
    }, 1000);
  };

  useEffect(() => {
    getListData();
  }, [location]);

  const [searchQuery, setSearchQuery] = useState(''); 
  const filteredData = dataList?.data?.filter(item => {
    const fullName = `${item?.auth_user?.first_name} ${item?.auth_user?.last_name}`.toLowerCase();
    const type = item?.type.toLowerCase();
    const ratingOrSubject = item?.recommendation.toLowerCase();
    const feedbackOrComplaint = item?.textfield.toLowerCase();

    return (
      fullName.includes(searchQuery.toLowerCase()) ||
      type.includes(searchQuery.toLowerCase()) ||
      ratingOrSubject.includes(searchQuery.toLowerCase()) ||
      feedbackOrComplaint.includes(searchQuery.toLowerCase())
    );
  });

  return (
    <>
      <div className="pt-7 px-4">
        {!isLoading && (
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">All Feedback</h3>

                  <div className="d-flex flex-row">
                    {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                    <Input
        className="mr-4"
        type="text"
        placeholder="Search"
        size='sm'
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
                    {/* <Button
                      className="p-3"
                      size="sm"
                      to="/admin/contactUs/addcontactUs"
                      tag={Link}
                    >
                      +Add
                    </Button> */}
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">S.NO.</th>
            <th scope="col">Name</th>
            <th scope="col">Type(Feedback/Complaint)</th>
            <th scope="col">Rating / Subject</th>
            <th scope="col">Feedback/Complaints Given</th>
            <th scope="col">Date / Time</th>
          </tr>
        </thead>
        <tbody>
          {filteredData?.map((item, index) => (
            <tr key={index}>
              <td>{((currentPage - 1) * perPage) + index + 1}</td>
              <td>{item?.auth_user?.first_name}{" "}{item?.auth_user?.last_name}</td>
              <td>{item?.type}</td>
              <td>{item?.recommendation}</td>
              <td>{item?.textfield}</td>
              <td>{moment(item?.updatedAt).format('DD-MM-YYYY hh:mm A')}</td>
            </tr>
          ))}
        </tbody>
      </Table>
                <CardFooter className="py-4">
                   <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/feedback?"
                  /> 
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};




export default Feedback